import firebase from "firebase";
import * as bootstrap from "bootstrap";
import {setNotify } from "reduxStore/actions";

/**
 * admin-r48yb
 * merchant-kzbxv
 * store-jaz57
 */
//  firebase.auth().tenantId = "merchant-kzbxv";

const sendPhoneVerifcationCode = async (phoneNumber, recaptchaVerifier) => {
  const phoneProvider = new firebase.auth.PhoneAuthProvider();
  const verificationId = await phoneProvider.verifyPhoneNumber(
    phoneNumber,
    recaptchaVerifier.current
  );

  return verificationId;
};

const signInWithPhone = async (verificationId, verificationCode) => {
  const credential = firebase.auth.PhoneAuthProvider.credential(
    verificationId,
    verificationCode
  );

  await firebase.auth().signInWithCredential(credential);
};

/**
 * sign in with email and password to firebase auth
 * @param {String} email
 * @param {String} password
 *  @returns {Boolean} true if sign in succeeded
 */
const signInWithEmail = async (email, password) => {
  // console.log(firebase.auth().tenantId);
  await firebase.auth().setPersistence(firebase.auth.Auth.Persistence.SESSION);
  const userCredential = await firebase
    .auth()
    .signInWithEmailAndPassword(email, password);

  if (userCredential && !userCredential.user.emailVerified) {
    await firebase.auth().signOut();
    throw new Error(
      "Email is not verified ! Please verify your email before sign in."
    );
  }

  return userCredential;
};

/**
 * sign out from firebase auth
 */
const signOut = async () => {
  await firebase.auth().signOut().then(() => {
    // 其他登出操作...
  }).catch((error) => {
    console.error('Error signing out:', error);
  });;
  setNotify({ toggle:true,message: "You have logged out.", type: "warning" });
  window.onbeforeunload = null;
  window.location.reload();
  
};

/**
 * sign up using email and password
 * @param {String} email
 * @param {String} password
 */
const createUserWithEmail = async (email, password) => {
  const userCredential = await firebase
    .auth()
    .createUserWithEmailAndPassword(email, password);

  if (userCredential && userCredential.user) {
    userCredential.user.sendEmailVerification();
  }
};

/**
 * Confirm user email with a given action code
 * @param {String} code
 */
const confirmEmail = async (code) => {
  await firebase.auth().applyActionCode(code);
};

/**
 * resend an email to verify the user's email
 * @param {String} email
 * @param {String} password
 * @param {Function} handleErr errHandling function
 */
const resendEmailVerification = async (email, password, handleErr) => {
  firebase
    .auth()
    .signInWithEmailAndPassword(email, password)
    .then((userCredential) => {
      if (userCredential && userCredential.user) {
        userCredential.user.sendEmailVerification().then(() => {
          firebase.auth().signOut();
        });
      }
    })
    .catch((err) => handleErr(err.message || err));
};

/**
 * Send reset email request
 * @param {String} email
 */
const sendResetPasswordEmail = async (email) => {
  const actionCodeSettings = {
    url: "https://admin.chapter-i.com/reset-password",
    handleCodeInApp: true,
  };
  await firebase.auth().sendPasswordResetEmail(email, actionCodeSettings);
};

/**
 * Reset password
 * @param {String} code credential token
 * @param {String} newPassword
 */
const resetPassword = async (code, newPassword) => {
  const userEmail = await firebase.auth().verifyPasswordResetCode(code);

  await firebase.auth().confirmPasswordReset(code, newPassword);
  await firebase.auth().signInWithEmailAndPassword(userEmail, newPassword);
};

/**
 * update current signed in user password
 * @param {String} currentPassword
 * @param {String} newPassword
 */
const updatePassword = async (currentPassword, newPassword) => {
  const user = firebase.auth().currentUser;

  if (user) {
    const credential = await getEmailAccountCredential(
      user.email,
      currentPassword
    );

    if (credential) {
      const userCredential = await user.reauthenticateWithCredential(
        credential
      );

      await updatePasswordByUserCredential(newPassword, userCredential);
    }
  } else {
    throw new Error("Current User is null");
  }
};

/**
 * update password by providing new password and userCredential
 * @param {String} newPassword
 * @param {Object} userCredential firebase auth userCredential
 */
const updatePasswordByUserCredential = async (newPassword, userCredential) => {
  await userCredential.user.updatePassword(newPassword);
};

/**
 * Get email account credential object from firebase auth
 * @param {String} email
 * @param {String} password
 */
const getEmailAccountCredential = async (email, password) => {
  return firebase.auth.EmailAuthProvider.credential(email, password);
};

const signInUpWithGoogle = async () => {
  const provider = await createGoogleProvider();

  return signInWithProvider(provider);
};

const createGoogleProvider = () => {
  return new firebase.auth.GoogleAuthProvider();
};

const signInWithProvider = async (provider) => {
  await firebase.auth().setPersistence(firebase.auth.Auth.Persistence.SESSION);
  return firebase.auth().signInWithPopup(provider);
};

const signInUpWithFacebook = async () => {
  const provider = await createFacebookProvider();

  return signInWithProvider(provider);
};

const createFacebookProvider = () => {
  return new firebase.auth.FacebookAuthProvider();
};

// every fetch run this
const getUserIdToken = async () => {
  if (firebase.auth().currentUser) {
    return firebase.auth().currentUser.getIdToken();
  }
};

const getUserUid = () => {
  if (firebase.auth().currentUser) {
    return firebase.auth().currentUser.uid;
  }
};

export {
  signInWithEmail,
  signOut,
  createUserWithEmail,
  confirmEmail,
  resendEmailVerification,
  sendResetPasswordEmail,
  resetPassword,
  updatePassword,
  signInUpWithGoogle,
  signInUpWithFacebook,
  getUserIdToken,
  getUserUid,
  sendPhoneVerifcationCode,
  signInWithPhone,
};
